import { ErrorContentGenerator, ErrorContentMap, InvalidFieldMessages } from "./getAlertContent";
import { MfaFields, MfaStepProps } from "../../components/SmartErrorAlert";
import { AxiosResponse } from "axios";
import { MfaDeleteErrorResponse, MfaEnrollStep1Response, MfaEnrollStep2Response } from "../../../mfa/hooks/useMfaApi";
import { serviceError } from "./mfaEnrollStep1Errors";

export type MfaDeleteErrorState = "MFA_SERVER_ERROR" | "UNKNOWN";

export const apiErrorContent: ErrorContentMap<MfaDeleteErrorState> = {
    MFA_SERVER_ERROR: serviceError,
    UNKNOWN: serviceError
}

const invalidFieldMessages: InvalidFieldMessages<"field"> = { // No validation alerts for this step, so this isn't actually used
    field: {
        linkText: 'none',
        messages: {empty: 'none'}
    }
}

export const deleteErrFns = new ErrorContentGenerator<MfaStepProps, MfaFields, MfaDeleteErrorState>({
    apiErrorContent: apiErrorContent,
    invalidFieldHeader: "none", // No validation alerts for this step, so this isn't actually used
    getRefMap,
    getErrState,
    invalidFieldMessages,
    getApiInvalidFields: () => [],
    isIntermediateStep: false
});

function getRefMap(props: MfaStepProps) {
    return {
        field: props.fieldRef
    }
}

function getErrState(apiResponse: AxiosResponse<MfaEnrollStep1Response | MfaEnrollStep2Response | MfaDeleteErrorResponse> | null) {
    if (!apiResponse || !apiResponse.data.errors || apiResponse.data.code === 400 || apiResponse.data.code === 401) {
        return null;
    }
    if (apiResponse.data.code === 500) {
        return "MFA_SERVER_ERROR";
    } else {
        return 'UNKNOWN';
    }
}
